// Module-level "a print run is happening right now" flag, shared by non-React code
// (the axios 401 interceptor) and React (Layout background polls). Zebra Browser
// Print runs locally and needs no server token, so a background 401 (e.g. an
// expired session) must NOT hard-redirect and kill the in-flight print loop.
//
// SECURITY BOUND: the deferral is capped. isPrintActive() self-expires after
// MAX_MS so a hung/lost print can never hold a session (and its MFA posture)
// open indefinitely — once it lapses, a 401 logs out normally and the batch
// lands in the "interrupted — completion unknown" state.
const MAX_MS = 6 * 60 * 1000;

let _active = false;
let _since = 0;
const subs = new Set();

function emit() { subs.forEach((f) => { try { f(_active); } catch { /* ignore */ } }); }

export function beginPrintActive() { _active = true; _since = Date.now(); emit(); }

export function endPrintActive() { if (_active) { _active = false; _since = 0; emit(); } }

export function isPrintActive() {
  if (!_active) return false;
  if (Date.now() - _since > MAX_MS) { endPrintActive(); return false; }
  return true;
}

export function subscribePrintActive(fn) { subs.add(fn); return () => subs.delete(fn); }
